import { Start } from '../../components/start/start';
import { Screen } from '../../components/layout/screen/screen';

export const StartContainer = () => {
    return (
        <Screen>
            <Start />
        </Screen>
    );
};
